/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayModal } from '@insticator/insticator-ui'; // iui-state
// component
import EmbedName from 'material/embeds/embedname/embedname';



/* ========== ~~~~~~~~~~ EMBED NAME : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    siteURL: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.siteURL,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    changeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected ||
        embedsState.embedManagementState.contentStatus.contentChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmbedName);
